<div class="min-h-dvh w-full bg-dark-sky bg-cover bg-center grid place-items-center relative">
  <div class="w-full h-full bg-black/40 absolute inset-0 z-0"></div>
  <div class="text-center z-10">
    <h1 class="text-[180px] font-bold text-surface-400 opacity-50 leading-none md:text-[250px]">
      404
    </h1>
    <h2 class="text-3xl md:text-4xl font-semibold mb-4 text-surface-0">
      {{ 'pageNotFound.title' | transloco }}
    </h2>
    <p class="text-lg md:text-xl max-w-lg mb-4 text-gray-300">
      {{ 'pageNotFound.messages.' + messageIndex | transloco }}
    </p>
  </div>
  <div class="text-center">
    <p-button [label]="'pageNotFound.backHome' | transloco" routerLink="/" size="large" rounded />
  </div>
</div>
